<h4>Opdatering klar – få de nyeste funktioner!</h4>
<p>
  Genindlæs portalen for at undgå fejl ved indsendelse af data.<br />
  Du får samtidig adgang til den nyeste funktionalitet.
</p>
<button mat-raised-button matSnackBarAction (click)="onAction()">Genindlæs <mat-icon>refresh</mat-icon></button>
